import { render, staticRenderFns } from "./more-news.vue?vue&type=template&id=538bf27c&scoped=true&"
import script from "./more-news.vue?vue&type=script&lang=js&"
export * from "./more-news.vue?vue&type=script&lang=js&"
import style0 from "./more-news.vue?vue&type=style&index=0&id=538bf27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538bf27c",
  null
  
)

export default component.exports